import {
  type D2CSiteBusinessProfile,
  type D2CSiteContactProfile,
  type D2CSiteImageItem,
  type D2CSiteImageList,
} from '@orcar/common';

// 회사가 ERP 자사몰관리 > 사이트 내용에서 고치는 값. 서버에 처음 넣은 값과 같고,
// 내용 API 응답 전이나 실패했을 때만 쓴다. 바꿀 때는 ERP에서 게시한다.
export const BUSINESS_PROFILE_FALLBACK: D2CSiteBusinessProfile = {
  tradeName: '제주로렌트카',
  registrationNumber: '873-87-00980',
  representative: '고 경 필',
  mailOrderNumber: '제 2018-제주도두-0009 호',
  address: '제주특별자치도 제주시 오일장중길 128(도두이동)',
  phone: '064-744-1116',
  fax: '064-744-1176',
  email: 'heyjin1136@nate.com',
  rentalOperators:
    '(주)갤럭시 렌터카 · (주)제주유명렌트카 · (주)그린렌트카 · (주)하나로렌트카',
  copyright: 'Copyright © 2015 jejurorent All Rights Reserved.',
};

export const CONTACT_PROFILE_FALLBACK: D2CSiteContactProfile = {
  kakaoChannelUrl: 'https://pf.kakao.com/_ndFtC/chat',
  instagramUrl: 'https://www.instagram.com/jejurorentcar/',
  facebookUrl: 'https://www.facebook.com/jejurorentcar/',
  youtubeUrl:
    'https://youtube.com/channel/UCYuW1Pd9kzTIFKe0IrH_sTg?si=P6vy1che201nuaFV',
};

const shown = { startAt: '', endAt: '', visible: true };

const hero = (
  id: string,
  image: string,
  mobileImage = '',
  copy: Partial<D2CSiteImageItem> = {},
): D2CSiteImageItem => ({
  id,
  image,
  mobileImage,
  eyebrow: '',
  title: '',
  titleLine2: '',
  subtitle: '',
  brightPhoto: false,
  ...copy,
  ...shown,
});

// 홈 첫 화면 이미지·배너·팝업. 내용 API가 실패했을 때만 쓴다.
export const HOME_HERO_FALLBACK: D2CSiteImageList = {
  items: [
    hero('car_lineup', '/assets/img/jejuro_hero_3.jpg', '', {
      eyebrow: '빠른 인수 · 빠른 반납',
      title: '사전 체크인으로',
      titleLine2: '인수도 반납도 빠르게',
      subtitle: '복잡한 절차 없이, 도착하면 바로 출발하세요',
      brightPhoto: true,
    }),
    hero(
      'blackbox',
      '/assets/img/jejuro_hero_blackbox.jpg',
      '/assets/img/jejuro_hero_blackbox_mobile.jpg',
    ),
    hero(
      'pet',
      '/assets/img/jejuro_hero_pet.jpg',
      '/assets/img/jejuro_hero_pet_mobile.jpg',
    ),
    hero('supercar', '/assets/img/jejuro_hero_supercar.jpg'),
  ],
};

const banner = (
  id: string,
  eyebrow: string,
  title: string,
): D2CSiteImageItem => ({
  id,
  image: `/assets/img/jejuro_${id}_desktop.jpg`,
  mobileImage: `/assets/img/jejuro_${id}_mobile.jpg`,
  eyebrow,
  title,
  ...shown,
});

export const HOME_BANNERS_FALLBACK: D2CSiteImageList = {
  items: [
    banner('kiosk', '간편한 차량인수', '무인 키오스크'),
    banner('goods', '공항보다 저렴한 다양한 기념품', '제주 굿즈샵'),
    banner('coffee', '재방문 고객을 위한', '무료 커피'),
  ],
};

const popup = (name: string, alt: string): D2CSiteImageItem => ({
  id: name,
  image: `/assets/promo/revive-${name}.png`,
  alt,
  link: '',
  ...shown,
});

export const HOME_POPUP_FALLBACK: D2CSiteImageList = {
  items: [
    popup('mileage', '마일리지 적립·사용 부활'),
    popup('referral', '친구추천 혜택 복귀'),
    popup('thanks', '기다려주셔서 감사합니다'),
  ],
};
